var isErrorWithMessage = function (error) {
  return typeof error === 'object' && error !== null && 'message' in error && typeof error.message === 'string';
};
var toErrorWithMessage = function (maybeError) {
  if (isErrorWithMessage(maybeError)) return maybeError;
  try {
    return new Error(JSON.stringify(maybeError));
  } catch (_a) {
    // Fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return new Error(String(maybeError));
  }
};
var getErrorMessage = function (error) {
  return toErrorWithMessage(error).message;
};
export { getErrorMessage, isErrorWithMessage, toErrorWithMessage };